import styled from 'styled-components';
import { Normal, H6 } from 'components/Core/Typography';

const Container = styled.div`
  padding: 0;
  display: flex;

  .webinar-hero--info-strip-item {
    display: flex;
    align-items: center;
    margin-right: 22px;

    .webinar-hero--info-strip-icon {
      width: 20px;
      height: 20px;
      margin-right: 12px;
      display: flex;
      justify-content: center;
    }

    .webinar-hero--info-strip-label {
      font-size: 16px;
      line-height: 150%;
      color: var(--blue-tertiary);
      margin: 0;
    }
  }

  @media (max-width: 576px) {
    flex-direction: column;

    .webinar-hero--info-strip-item {
      margin-right: 0;
      margin-bottom: 10px;
    }
  }
`;

const Kicker = styled(Normal)`
  color: var(--neutral-6);
  margin-bottom: 10px;
`;

const Title = styled(H6)`
  color: var(--black-color);
  @media (max-width: 992px) {
    font-size: 16px;
  }
`;

export { Container, Kicker, Title };
